import React, { useState } from "react";
import "./test.css";
import StudentCBTExamsLogin from "../computer_base_assessment_components/computer_base_examination/student_components/StudentCBTExamsLogin";

export default function Test() {
  return (
    <section className="sectionTesting">
      <StudentCBTExamsLogin />
      <AllahuAkbarModal />
    </section>
  );
}

const AllahuAkbarModal = () => {
  const [show, setShow] = useState(false);

  return (
    <>
      <button onClick={() => setShow(true)} className="std_form-button">
        Open Modal
      </button>

      {show && (
        <div className="std_form-modal-overlay" onClick={() => setShow(false)}>
          <div
            className="std_form-modal-box"
            onClick={(e) => e.stopPropagation()}
          >
            <h2>Allahu Akbar</h2>
            <p>
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Nihil
              libero iusto numquam illum quis sed quisquam, quam illo accusamus
              voluptas quod non voluptatum voluptates? Id, aliquam et maxime
              labore voluptate fuga animi. Voluptatum similique natus cupiditate
              ab sed explicabo vero illum necessitatibus officiis ipsam nulla
              perferendis accusantium veritatis impedit quo eligendi, maiores
              neque aliquam modi.
            </p>
            <button onClick={() => setShow(false)} className="std_form-close">
              Close
            </button>
          </div>
        </div>
      )}
    </>
  );
};
